import { IAIChatContext } from './interfaces';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import createPersonaChat from './api/createPersonaChat';
import getPersonaChat from './api/getPersonaChat';
import sendChatMessage from './api/sendChatMessage';
import getChatMessages from './api/getChatMessages';
import addPersonaPair from './api/AddPersonaPair';
import getPersonaPair from "./api/GetPersonaPair";

const store = {
  messages: [],
};

export const getAIChatInitialData = async function (
  flowAPI: ControllerFlowAPI,
): Promise<IAIChatContext> {
  return {
    currentChatId: null,
    currentChatPair: null,
    chat: null,
    messages: [],
    setCurrentChatId(currentChatId: string) {
      flowAPI.controllerConfig.setProps({
        currentChatId,
      });
    },
    async createPersonaChat(personaId: string, firstMessage) {
      void createPersonaChat(flowAPI, personaId, firstMessage);
    },
    async requestPersonaChat(chatId: string) {
      void getPersonaChat(flowAPI, chatId);
    },
    async sendChatMessage(chatId: string, message: string, attachments: any) {
      void sendChatMessage(flowAPI, chatId, message, store);
    },
    async requestChatMessages(chatId: string) {
      void getChatMessages(flowAPI, chatId, store);
    },
    async addPersonaPair(personaId: string, programId: string) {
      void addPersonaPair(flowAPI, personaId, programId);
    },
    async getPersonaPair(personaId: string, programId: string) {
      void getPersonaPair(flowAPI, personaId, programId);
    },
  };
};
